import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import PropTypes from "prop-types";
import {
  tooltipContentStyle,
  tooltipItemStyle,
  tooltipLabelStyle,
  chartColors,
  defaultGridStyle,
  defaultLineProps,
} from "./ChartStyles";
import "./TrendsLineTile.scss";

const TrendsLineTile = ({
  title = "Sales Trends",
  subtitle = null,
  data = [],
  xKey = "month",
  series = [
    { key: "thisYear", name: "This Year", color: chartColors.accent },
    { key: "lastYear", name: "Last Year", color: chartColors.primary },
  ],
  showGrid = true,
}) => {
  return (
    <div
      className="trends-line-tile p-4"
      style={{ width: `100%`, height: `100%` }}
    >
      <h6 className="tile-title mb-2">{title}</h6>
      {subtitle && <p className="tile-subtitle mb-3">{subtitle}</p>}

      <ResponsiveContainer width="100%" height="90%">
        <LineChart data={data}>
          {showGrid && <CartesianGrid {...defaultGridStyle} />}
          <XAxis
            dataKey={xKey}
            tick={{ fill: "#6c757d", fontSize: "0.75rem" }}
            axisLine={false}
            tickLine={false}
          />
          <YAxis
            tick={{ fill: "#6c757d", fontSize: "0.75rem" }}
            axisLine={false}
            tickLine={false}
          />
          <Tooltip
            contentStyle={tooltipContentStyle}
            itemStyle={tooltipItemStyle}
            labelStyle={tooltipLabelStyle}
            formatter={(value, name) => [`$${value.toLocaleString()}`, name]}
          />
          <Legend
            verticalAlign="top"
            height={20}
            iconType="circle"
            iconSize={8}
            wrapperStyle={{ fontSize: "0.75rem", color: "#6c757d" }}
          />

          {series.map((s, i) => (
            <Line
              key={i}
              {...defaultLineProps}
              dataKey={s.key}
              name={s.name}
              stroke={s.color}
              dot={{ r: 3 }}
            />
          ))}
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

TrendsLineTile.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  data: PropTypes.array.isRequired,
  xKey: PropTypes.string,
  series: PropTypes.array,
  width: PropTypes.number,
  height: PropTypes.number,
  showGrid: PropTypes.bool,
};

export default TrendsLineTile;
